import {
  EMPLOYEECONTRACTTYPE_LOADING,
  GET_EMPLOYEECONTRACTTYPE,
  GET_EMPLOYEECONTRACTTYPE_SUCCESS,
  GET_EMPLOYEECONTRACTTYPE_FAIL,
  ADD_EMPLOYEECONTRACTTYPE_SUCCESS,
  ADD_EMPLOYEECONTRACTTYPE_FAIL,
  DELETE_EMPLOYEECONTRACTTYPE_SUCCESS,
  DELETE_EMPLOYEECONTRACTTYPE_FAIL,
  UPDATE_EMPLOYEECONTRACTTYPE_SUCCESS,
  UPDATE_EMPLOYEECONTRACTTYPE_FAIL,
  EMPLOYEECONTRACTTYPE_RESET
} from "./actionType";

const INIT_STATE = {
  employeeContractTypes: [],
  error: {},
};

const EmployeeContractType = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEECONTRACTTYPE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_EMPLOYEECONTRACTTYPE:
          return {
            ...state,
            employeeContractTypes: action.payload.data,
            isEmployeeContractTypeCreated: false,
            isEmployeeContractTypeSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_EMPLOYEECONTRACTTYPE_FAIL:
      switch (action.payload.actionType) {
        case GET_EMPLOYEECONTRACTTYPE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isEmployeeContractTypeCreated: false,
            isEmployeeContractTypeSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_EMPLOYEECONTRACTTYPE: {
      return {
        ...state,
        isEmployeeContractTypeCreated: false,
        loading: true,
      };
    }

    case EMPLOYEECONTRACTTYPE_LOADING: {
      return {
        ...state,
        isEmployeeContractTypeCreated: false,
        loading: true,
      };
    }

    case ADD_EMPLOYEECONTRACTTYPE_SUCCESS:
      return {
        ...state,
        isEmployeeContractTypeCreated: true,
        loading: false,
        employeeContractTypes: [action.payload.data, ...state.employeeContractTypes],
      };

    case ADD_EMPLOYEECONTRACTTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_EMPLOYEECONTRACTTYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeContractTypes: state.employeeContractTypes.filter(
          employeeContractType => employeeContractType.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_EMPLOYEECONTRACTTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_EMPLOYEECONTRACTTYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeContractTypes: state.employeeContractTypes.map(employeeContractType =>
          employeeContractType.id.toString() === action.payload.data.id.toString() ? { ...employeeContractType, ...action.payload.data } : employeeContractType
        ),
      };

    case UPDATE_EMPLOYEECONTRACTTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case EMPLOYEECONTRACTTYPE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default EmployeeContractType;